<template>
    <div class="overview-card">
        <div class="d-flex items-wrapper" v-if="visibility">
            <CardItem 
                v-for="data in overviewCardData"
                :key="`${data.title}-${data.icon}`"
                :data="data"/>
        </div>
    </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { useRouter, useStore } from '../../../core/hooks'
import CardItem from './CardItem'
import useOverviewCard from './useOverviewCard'

export default {
    name: 'OverviewCard',
    components: {
        CardItem
    },
    setup() {
        const { route, router } = useRouter() 
        const { state } = useStore()
        const { overviewCardData } = useOverviewCard()
        const visibility = computed(() => state.value.publishedCampaignIds.length && (route.value.name === 'requests' || route.value.name === 'updates'))
        return {
            visibility,
            overviewCardData
        }
    }
}
</script>

<style lang="scss" scoped>
.overview-card {
    div.items-wrapper {
        margin-bottom: 48px;
    }
}
</style>